module.exports = __webpack_public_path__ + "5ceb2e3b75b6e9b6f7744e3bc4a98a2d.svg";